import { BookableArea, BookingZone } from "../types/venues";

/**
 * Sorts bookable_area_zones based on the order they appear in bookable_areas.
 * The function maintains the order of zones as they first appear in the bookable_areas array.
 *
 * @param zones - Array of BookingZone objects to be sorted
 * @param areas - Array of BookableArea objects that determine the sort order
 * @returns Sorted array of BookingZone objects
 */
export const sortZonesByAreaOrder = (
  zones: BookingZone[],
  areas: BookableArea[]
): BookingZone[] => {
  if (!zones || !areas || zones.length === 0 || areas.length === 0) {
    return zones || [];
  }

  // Create a map to track the first occurrence of each zone in the areas array
  const zoneOrderMap = new Map<string, number>();

  areas.forEach((area, index) => {
    if (area.zone && !zoneOrderMap.has(area.zone)) {
      zoneOrderMap.set(area.zone, index);
    }
  });

  // Sort zones based on their first appearance in areas, keeping original order for zones not found
  return [...zones].sort((a, b) => {
    const orderA = zoneOrderMap.get(a.id);
    const orderB = zoneOrderMap.get(b.id);

    // If both zones are found in areas, sort by their first occurrence
    if (orderA !== undefined && orderB !== undefined) {
      return orderA - orderB;
    }

    // If only one is found, prioritize the found one
    if (orderA !== undefined) return -1;
    if (orderB !== undefined) return 1;

    // If neither is found, maintain original order
    return 0;
  });
};

export const removeZonesFromArea = (
  areas: BookableArea[] | undefined
): BookableArea[] => {
  if (!areas) return [];
  return areas.map((area) => ({
    ...area,
    zone: undefined
  }));
};
